import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { BinStatusFragments } from '../../graphql/binStatus.graphql';
import { BinStatus } from '../../types/bin/binStatus';
import { binStatusSlice } from '../../context/BinStatusContext';
import { useAppDispatch } from '../../ui/pages/store';

const binStatusSubscription = gql`
  subscription binStatusNotification($companyId: String!) {
    binStatusNotification(companyId: $companyId) {
      companyId
      entities {
        ...BinStatus
      }
      topic
      date
    }
  }
  ${BinStatusFragments.binStatus}
`;

export class BinStatusNotificationResponse extends forNotification<BinStatus>('binStatusNotification') {}

export default function BinStatusNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: binStatusNotification } = useSubscription<BinStatusNotificationResponse>(binStatusSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleBinStatusNotification = (notification?: BinStatusNotificationResponse) => {
    if (!notification?.binStatusNotification) return;
    const binStatusNotification = notification.binStatusNotification;

    switch (binStatusNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(binStatusSlice.actions.add(binStatusNotification.entities));
        break;
      case 'DELETE':
        dispatch(binStatusSlice.actions.delete(binStatusNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleBinStatusNotification(binStatusNotification);
  }, [binStatusNotification]);

  return <></>;
}
